import { type Accessor, Match, Switch, createEffect, createSignal } from "solid-js";
import type { JSX } from "solid-js/h/jsx-runtime";
import { useTranslation } from "~/primitives/translator";

export interface TranslationFieldProps {
	key?: string;
	children?: (value: Accessor<string | undefined>) => JSX.Element | string;
}

export function TranslationField(props: TranslationFieldProps) {
	const [value, setValue] = createSignal<string>();

	const handleValue = (value: string) => {
		setValue(value);
	};

	createEffect(() => {
		if (props.key) {
			useTranslation(props.key).then(handleValue);
		} else {
			setValue("");
		}
	});

	return (
		<Switch>
			<Match when={props?.children === undefined}>{value() ?? ""}</Match>
			<Match when={typeof props?.children === "function" && props.children}>
				{(props.children as any)(value)}
			</Match>
		</Switch>
	);
}
